/**
 * Gift flow error codes.
 */
export enum GiftErrorCode {
  CLAIM_FAILED = 'error.gift.claim.failed',
}
